import styled from 'styled-components';
import { color } from 'styles/pallete';

interface ContainerProps {
	width: number;
}

export const container = styled.div<ContainerProps>`
	width: fit-content;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: help;
	> svg {
		font-size: ${(props) => `${props.width}rem`};
		color: ${color.interface.lightGray};
	}
`;
